import LandingPageLayout from 'components/LandingPageLayout';
import RentalMontReal from 'components/v1-tailwindcss/RentalMontReal';
import React from 'react';
import Head from 'next/head';
import BestUnderStatement from 'components/v1-tailwindcss/BestUnderStatement';
import AvailableOptions from 'components/v1-tailwindcss/AvailableOptions';

export default function RentalsInMontreal() {
  return (
    <>
      <Head>
        <meta charset="utf-8" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>Apartments for rent in Montreal</title>
        <meta name="author" content="SoulRooms" />
        <meta property="og:site_name" content="SoulRooms" />
        <meta property="og:title" content="Apartments for rent in Montreal | Soulrooms" />
        <meta
          property="og:description"
          content="Find   the   apartments   for   rent   in   the   heart   of
          downtown Montreal. To learn more about our rentals click here."
        />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://img1.wsimg.com/isteam/videos/naBxa52" />
        <meta property="og:locale" content="en_US" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@soulroomsTO" />
        <meta name="twitter:title" content="SoulRooms" />
        <meta
          name="twitter:description"
          content="SoulRooms enables landlords to rent efficiently
           to modern renters. For renters, it's the platform to
           find the housing they want, without much hassle. "
        />
        <meta name="twitter:image" content="https://img1.wsimg.com/isteam/videos/naBxa52" />
        <meta name="twitter:image:alt" content="SoulRooms" />
        <meta name="theme-color" content="#FCBD00" />
      </Head>
      <LandingPageLayout>
        <div className="container lg:px-4 px-6 mx-auto">
          <RentalMontReal
            link="#JotFormIFrame-91797058303261"
            imgSrc="/static/images/landingPages/RentalMontReal/montreal-img.webp"
            title="Looking for the best rentals in MONTREAL?"
            loc="Location -  Multiple"
            para1=""
            para2="Whether you are working in the downtown area, studying in one of the city's universities, or simply looking to make this beautiful city your home, consider yourself covered you covered with a curated list of properties from some of the best landlords in Montreal. "
            btn_text="Find properties"
          />
          <BestUnderStatement title="BEST IS AN UNDERSTATEMENT" />
          <AvailableOptions title="FILL IN YOUR REQUIREMENTS & SEE AVAILBLE OPTION">
            <iframe
              id="JotFormIFrame-91797058303261"
              title="Find a SoulRoom"
              onload="window.parent.scrollTo(0,0)"
              allowtransparency="true"
              allowfullscreen="true"
              allow="geolocation; microphone; camera"
              src="https://form.jotform.com/91797058303261"
              frameborder="0"
            //   style="
            // min-width: 100%;
            // height:539px;
            // border:none;"
              scrolling="no"
              style={{
                width: '100%',
                overflow: 'visible',
                transition: 'height 1.5s ease 0s',
                height: '644px',
              }}></iframe>
          </AvailableOptions>
        </div>
      </LandingPageLayout>
    </>
  );
}
